import { useProductsContext } from '../Providers/ProductsProvider';

// Hook that uses the Products context
export const useProducts = () => {
  return useProductsContext();
};

export default useProducts;
